









































































































import {
  defineComponent,
  ref,
  useContext
} from '@nuxtjs/composition-api';
import { useContactForm } from '@wemade-vsf/contact';
import { useEvent } from '@wemade-vsf/composables';
import { SfInput, SfTextarea, SfHeading, SfButton, SfLoader } from '@storefront-ui/vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import  { EmailTypeEnum } from '@wemade-vsf/magento-api';

extend('email', {
  ...email,
  message: 'Invalid email',
});

extend('required', {
  ...required,
  message: 'This field is required',
});

export default defineComponent({
  name: 'ContactForm',
  props: {
    title: {
      type: String,
      default: ''
    },
    buttontext: {
      type: String,
      default: ''
    },
    showPhone: {
      type: Boolean,
      default: false
    },
    phoneRequired: {
      type: Boolean,
      default: false
    },
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    SfInput,
    SfTextarea,
    SfHeading,
    SfButton,
    SfLoader
  },
  setup (props) {
    const { i18n } = useContext();
    const { loading, error, sendEmail } = useContactForm();
    const formData = ref({
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      message: ''
    });
    const validationObserver = ref(null)
    const successMessage = ref('')
    const errorMessage = ref('')

    const onFormSubmit = async () => {
      const params = {
        subject: i18n.t('New Contact form submission'),
        senderEmail: formData.value.email,
        type: EmailTypeEnum.CONTACT,
        sendNotification: true,
        htmlBody: `
        ${i18n.t('You received a new message')}<br /><br />
        <table width="100%">
          <tr>
            <td>${i18n.t('First Name')}</td>
            <td>${formData.value.firstname}</td>
          </tr>
          <tr>
            <td>${i18n.t('Last Name')}</td>
            <td>${formData.value.lastname}</td>
          </tr>
          <tr>
            <td>${i18n.t('Email address')}</td>
            <td>${formData.value.email}</td>
          </tr>
          ${props.showPhone ? `
            <tr>
              <td>${i18n.t('Message')}</td>
              <td>${formData.value.phone}</td>
            </tr>
          ` : ''}
          <tr>
            <td>${i18n.t('Message')}</td>
            <td>${formData.value.message}</td>
          </tr>
        </table>
        `
      }
      const result = await sendEmail(params);
      if (result && !error.value.sendEmail) {
        successMessage.value = i18n.t('Your email has been sent.')
        useEvent('contact:submit', {
          type: `${params.type}`
        })
        formData.value = {
          firstname: '',
          lastname: '',
          email: '',
          phone: '',
          message: ''
        }
        validationObserver.value.reset()
      } else {
        errorMessage.value = i18n.t('An error occurred while processing your request. Please try again.')
      }
    }

    return {
      loading,
      formData,
      onFormSubmit,
      validationObserver,
      successMessage,
      errorMessage
    }

  }
})
